<template>
  <div class="animated fadeIn">
    <loader v-if="loading"></loader>
    <div v-if="!loading">
      <b-row>
        <b-col md="12">
          <!-- <v-card
          border-variant="info"
          header-bg-variant="primary"
          header-text-variant="white"
          class="full-width"
          >-->
          <div slot="header">
            <strong>Edit Subscription</strong>
            <eb-button
              style="color: white; font-weight: bold; float: right"
              text="Back"
              @click="(e) => $emit('edit', e)"
            ></eb-button>
          </div>
          <ValidationObserver v-slot="{ invalid }">
            <form class="mt-3">
              <v-card
                border-variant="info"
                header-bg-variant="primary"
                header-text-variant="white"
                class="full-width"
              >
                <div class="m-2 p-3">
                  <h2 style="color: #727cf5">General</h2>
                  <b-row>
                    <b-col md="4">
                      <div class="form-group">
                        <label for="planName">Name </label>
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          name="planName"
                        >
                          <b-form-input
                            class=""
                            id="planName"
                            inputType="text"
                            v-model="inputObject.planName"
                          />
                          <span class="validate-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </b-col>
                    <b-col md="4">
                      <div class="form-group">
                        <label for="scopeOptions">Scope </label>
                        <!-- <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Scope"
                    > -->
                        <eb-select
                          id="scopeOptions"
                          type="text"
                          label="label"
                          v-model="inputObject.scope"
                          :options="scopeOptions"
                          :selected="inputObject.scope"
                          placeholder="Select Scope type"
                          disabled
                        ></eb-select>
                      </div>
                      <!-- <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider> -->
                    </b-col>
                    <b-col md="4">
                      <b-row class="mt-4 ml-2">
                        <label for="status">Status :</label>
                        <c-switch
                          class="mx-1"
                          color="success"
                          v-model="inputObject.isActive"
                          label="label"
                          id="status"
                          variant="pill"
                          data-on="yes"
                          data-off="no"
                        />
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="8">
                      <label for="description">Description </label>
                      <br />
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="description"
                      >
                        <textarea
                          rows="4"
                          class="form-control"
                          cols="50"
                          id="description"
                          inputType="text"
                          maxlength="1500"
                          v-model="inputObject.description"
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-col>
                    <b-col md="4">
                      <div class="form-group">
                        <label for="orgAccessLevel">org Access Level </label>
                        <eb-select
                          type="text"
                          v-model="inputObject.orgAccessLevel"
                          :selected="inputObject.orgAccessLevel"
                          :options="orgAccessOptions"
                          label="label"
                          id="orgAccessLevel"
                          placeholder="Select org Access Level"
                          disabled
                        ></eb-select>
                      </div>
                      <div
                        v-if="
                          inputObject.orgAccessLevel &&
                          inputObject.orgAccessLevel.value === 'LIMITED'
                        "
                      >
                        <div class="form-group">
                          <label for="orgAccessLevel">org Access List </label>
                          <multiselect
                            v-model="inputObject.orgAccessList"
                            tag-placeholder="Add this as new org Access"
                            placeholder="Select org Access List"
                            label="name"
                            track-by="keys"
                            :options="orgAccessListOptions"
                            :multiple="true"
                            :taggable="false"
                            :open-direction="'bottom'"
                            disabled
                          ></multiselect>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </v-card>
              <v-card>
                <div class="m-2 p-3">
                  <h2 style="color: #727cf5">Pricing</h2>
                  <b-row>
                    <b-col md="4">
                      <div class="form-group">
                        <label for="paymentType">Payment Type </label>
                        <eb-select
                          id="paymentType"
                          type="text"
                          label="label"
                          v-model="inputObject.paymentType"
                          :selected="inputObject.paymentType"
                          :options="paymentType"
                          placeholder="Select payment type"
                          disabled
                        ></eb-select>
                      </div>
                    </b-col>
                    <b-col md="4">
                      <div class="form-group">
                        <label for="taxCode">Tax Code </label>
                        <!-- <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="taxCode"
                    > -->
                        <eb-select
                          id="taxCode"
                          type="text"
                          label="label"
                          v-model="inputObject.taxCode"
                          :selected="inputObject.taxCode"
                          :options="taxcodeoptions"
                          placeholder="Select tax code"
                          disabled
                        ></eb-select>
                      </div>
                      <!-- <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider> -->
                    </b-col>
                    <b-col md="4">
                      <div class="form-group">
                        <label for="chargeCode">Charge Code </label>
                        <!-- <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="chargeCode"
                    > -->
                        <b-form-input
                          id="chargeCode"
                          inputType="text"
                          maxlength="100"
                          v-model="inputObject.chargeCode"
                          readonly
                        />
                      </div>
                      <!-- <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider> -->
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4">
                      <div class="form-group">
                        <label for="currency">Currency </label>
                        <!-- <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="currency"
                    > -->
                        <b-form-input
                          id="currency"
                          inputType="Number"
                          maxlength="100"
                          v-model="inputObject.currency"
                          readonly
                        />
                      </div>
                      <!-- <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider> -->
                    </b-col>
                    <b-col md="4">
                      <!-- <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="price"
                    > -->
                      <div class="form-group">
                        <label for="price">Price </label>
                        <b-form-input
                          id="price"
                          type="number"
                          maxlength="100"
                          v-model="inputObject.price"
                          readonly
                        />
                      </div>
                      <!-- <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider> -->
                    </b-col>
                    <b-col
                      v-if="inputObject.cadencetype.value === 'EVENT'"
                      md="4"
                    >
                      <div class="form-group">
                        <label for="eventType">Event </label>
                        <eb-select
                          id="eventType"
                          type="text"
                          label="label"
                          v-model="inputObject.eventType"
                          :options="eventType"
                          placeholder="Select Event type"
                          :selected="inputObject.eventType"
                          disabled
                        ></eb-select>
                      </div>
                    </b-col>
                    <b-col md="4">
                      <div class="form-group">
                        <label for="uom">Unit Of Measurement </label>
                        <eb-select
                          id="uom"
                          type="text"
                          label="label"
                          v-model="inputObject.uom"
                          :selected="inputObject.uom"
                          :options="unitOfMeasurementtype"
                          placeholder="Select payment type"
                          disabled
                        ></eb-select>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4">
                      <div class="form-group">
                        <label for="baseQuantity"> Base Quantity </label>
                        <!-- <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="baseQuantity"
                    > -->
                        <b-form-input
                          id="baseQuantity"
                          inputType="Number"
                          maxlength="100"
                          v-model="inputObject.baseQuantity"
                          readonly
                        />
                      </div>
                      <!-- <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider> -->
                    </b-col>
                    <b-col md="4">
                      <!-- <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="price"
                    > -->
                      <div class="form-group">
                        <label for="cadence">Cadence Type </label>
                        <eb-select
                          id="cadence"
                          label="label"
                          v-model="inputObject.cadencetype"
                          :selected="inputObject.cadencetype"
                          :options="cadencetype"
                          placeholder="Select Cadence type"
                          disabled
                        ></eb-select>
                      </div>
                      <!-- <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider> -->
                    </b-col>
                    <b-col md="4">
                      <b-row class="mt-4 ml-2">
                        <label for="autoRenewal">Auto Renewal :</label>
                        <c-switch
                          class="mx-1"
                          color="success"
                          v-model="inputObject.autoRenewal"
                          label="label"
                          id="autoRenewal"
                          variant="pill"
                          data-on="yes"
                          data-off="no"
                        />
                      </b-row>
                    </b-col>
                  </b-row>
                </div>
              </v-card>
              <v-card>
                <div class="m-2 p-3">
                  <h2 style="color: #727cf5">Provisioning</h2>
                  <b-row>
                    <!-- <b-col md="4">
                      <label for="planAccess">Plan Access </label>
                      <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="planAccess"
                    > -->
                    <!-- <eb-select
                        style="background-color: #fff;width:75%;"
                        id="scopeOptions"
                        type="text"
                        label="label"
                        v-model="inputObject.planAccess"
                        :options="accessrulesList"
                        :selected="inputObject.planAccess"
                        placeholder="Select Scope type"
                        disabled
                      ></eb-select> -->
                    <!-- <b-input
                      style="width: 75%;"
                      id="rewardValue"
                      type="text"
                      v-model="inputObject.planAccess"
                    ></b-input> -->
                    <!-- <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                    </b-col> -->
                    <b-col md="4">
                      <div class="form-group">
                        <label for="plantype">Plan Type </label>
                        <!-- <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="plantype"
                    > -->
                        <eb-select
                          id="plantype"
                          type="text"
                          label="label"
                          v-model="inputObject.planType"
                          :selected="inputObject.planType"
                          :options="planType"
                          placeholder="Select plan type"
                          disabled
                        ></eb-select>
                      </div>
                      <!-- <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider> -->
                    </b-col>
                    <b-col md="4">
                      <div class="form-group">
                        <label for="validity">Validity </label>
                        <!-- <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="validity"
                    > -->
                        <b-form-input
                          id="validity"
                          inputType="Number"
                          maxlength="100"
                          v-model="inputObject.validity"
                          readonly
                        />
                      </div>
                      <!-- <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider> -->
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4">
                      <div class="form-group">
                        <label for="planlimit">Plan Limit </label>
                        <!-- <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="planlimit"
                    > -->
                        <b-form-input
                          id="planlimit"
                          inputType="text"
                          maxlength="100"
                          v-model="inputObject.planlimit"
                          readonly
                        />
                      </div>
                      <!-- <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider> -->
                    </b-col>
                    <b-col md="4">
                      <label for="planFeatures">Features </label>
                      <b-row
                        v-for="(e, idx) in inputObject.planFeatures"
                        :key="idx"
                      >
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          name="planFeatures"
                        >
                          <b-form-input
                            id="planFeatures"
                            class="ml-2"
                            style="width: 226px"
                            inputType="text"
                            v-model="e.planFeatures"
                          />
                          <span class="validate-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <b-button
                          btn-special="primary"
                          size="md"
                          style="background: #4dbd74"
                          class=""
                          @click="onClickEamilButton(e, idx)"
                        >
                          <i
                            v-if="!e.isRemovable"
                            class="fa fa-plus-circle mr-1"
                          ></i>
                          <i
                            class="fa fa-minus-circle"
                            v-if="e.isRemovable"
                          ></i>
                          {{ e.text }}
                        </b-button>
                      </b-row>
                    </b-col>
                    <b-col md="4">
                      <b-row class="mt-4 ml-2">
                        <!-- <label for="isActive">isActive :</label>
                      <c-switch
                        class="mx-1"
                        color="success"
                        v-model="isActive"
                        label="label"
                        id="isActive"
                        variant="pill"
                        data-on="yes"
                        data-off="no"
                      /> -->
                      </b-row>
                    </b-col>
                  </b-row>
                </div>
              </v-card>
              <div class="text-center mt-3 mb-3">
                <button
                  type="button"
                  class="btn btn-primary"
                  :disabled="invalid"
                  classic="mr-1 btn-primary"
                  text="Update"
                  @click.prevent="handleSubmit"
                >
                  Update
                </button>
              </div>
            </form>
          </ValidationObserver>
          <!-- </v-card> -->
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.esm";
import { Switch as cSwitch } from "@coreui/vue";
import cInput from "@/components/Common/CustomInput";
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
import subscriptionplanDetails from "@/components/MasterSetup/subscriptionplan/SubscriptionplanDetails";
import { mapGetters } from "vuex";
import loader from "@/components/loader/nipigeloader.vue";
export default {
  name: "EditSubscription",
  components: {
    ebButton,
    cSwitch,
    cInput,
    ValidationProvider,
    ValidationObserver,
    ebSelect,
    subscriptionplanDetails,
    loader,
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      show: true,
      loading: false,
      currentProvider: "",
      status: true,
      timingRules: [
        {
          within: "",
          totalLimit: "",
        },
      ],
      inputObject: {
        autoRenewal: true,
        cadencetype: "",
        scope: "",
        orgAccessLevel: "",
        orgAccessList: "",
        planName: "",
        taxCode: "",
        chargeCode: "",
        description: "",
        planType: "",
        isActive: true,
        planlimit: "",
        validity: "",
        planAccess: "",
        paymentType: "",
        cadencetype: "",
        eventType: "",
        price: "",
        currency: "",
        baseQuantity: "",
        uom: "",
        planFeatures: [
          {
            planFeatures: "",
            isRemovable: false,
            text: "Add",
          },
        ],
      },
      paymentType: [
        {
          label: "Prepaid",
          value: "PRE-PAID",
        },
        {
          label: "Postpaid",
          value: "POST-PAID",
        },
      ],
      orgAccessOptions: [
        {
          label: "GLOBAL",
          value: "GLOBAL",
        },
        {
          label: "LIMITED",
          value: "LIMITED",
        },
      ],
      cadencetype: [
        {
          label: "Monthly",
          value: "MONTHLY",
        },
        {
          label: "Quarterly",
          value: "QUARTERLY",
        },
        {
          label: "One time",
          value: "ONE-TIME",
        },
        {
          label: "Event",
          value: "EVENT",
        },
      ],
      scopeOptions: [
        {
          label: "PARTNER",
          value: "PARTNER",
        },
        {
          label: "CUSTOMER",
          value: "CUSTOMER",
        },
      ],
      planType: [
        {
          label: "DURATION",
          value: "DURATION",
        },
        {
          label: "LIMIT",
          value: "LIMIT",
        },
      ],
      eventType: [
        {
          label: "Order-Fulfilled",
          value: "ORDER_FULFILLED",
        },
      ],
      unitOfMeasurementtype: [
        {
          label: "Occurrence",
          value: "OCCURRENCE",
        },
        {
          label: "Minute",
          value: "MINUTE",
        },
        {
          label: "Second",
          value: "SECOND",
        },
        {
          label: "GB",
          value: "GB",
        },
        {
          label: "MB",
          value: "MB",
        },
        {
          label: "Amount",
          value: "AMOUNT",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      provider: "auth/getUserID",
    }),
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
    orgAccessListOptions() {
      let data = this.$store.getters["partner/GetPartnerList"];
      let tenantList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map((obj) => {
          if (this.inputObject.orgAccessLevel.value === "LIMITED") {
            let arrayObj = {
              keys: obj._id,
              name: obj.authentication.userName,
              ...obj,
            };
            tenantList.push(arrayObj);
          }
        });
        return tenantList;
      } else {
        return [];
      }
    },
    taxcodeoptions() {
      let data = this.$store.getters["taxcode/GetTaxcodeList"];
      if (Array.isArray(data) && data.length > 0) {
        return data.map((d) => ({
          label: d.taxCode,
          value: d._id,
        }));
      }
      return [];
    },
    accessrulesList() {
      let data = this.$store.getters["accessrule/accessRuleList"];
      if (Array.isArray(data) && data.length > 0) {
        return data.map((d) => {
          return {
            label: d.name.toUpperCase(),
            value: d._id,
          };
        });
      }
      return [];
    },
  },
  methods: {
    fetchingAllData() {
      this.inputObject.planName = this.details.planName;
      this.inputObject.scope = {
        label: this.details.scope,
        value: this.details.scope,
      };
      this.inputObject.isActive = this.details.isActive;
      this.inputObject.description = this.details.planDescription;
      let fiterOgroList = [];
      if (this.details.orgAccess.orgAccessLevel) {
        this.inputObject.orgAccessLevel = {
          label: this.details.orgAccess.orgAccessLevel.toUpperCase(),
          value: this.details.orgAccess.orgAccessLevel.toUpperCase(),
        };
      } else {
      }
      if (
        this.details.orgAccess.orgAccessList &&
        this.details.orgAccess.orgAccessLevel == "LIMITED"
      ) {
        this.details.orgAccess.orgAccessList.forEach((obj) => {
          let eachFilteredList = this.orgAccessListOptions.filter((element) => {
            return element._id == obj;
          });
          fiterOgroList.push(eachFilteredList);
        });
      }
      let modifiedOrgodata = [];
      fiterOgroList.forEach((obj) => {
        modifiedOrgodata.push(obj[0]);
      });
      this.inputObject.orgAccessList = modifiedOrgodata;
      this.inputObject.paymentType = {
        label: this.details.paymentType,
        value: this.details.paymentType,
      };
      let taxCodeFilter = this.$store.getters["taxcode/GetTaxcodeList"].filter(
        (obj) => {
          return obj._id == this.details.taxCode;
        }
      );
      if (taxCodeFilter.length > 0) {
        this.inputObject.taxCode = {
          label: taxCodeFilter[0].taxCode,
          value: taxCodeFilter[0]._id,
        };
      } else {
      }
      this.inputObject.chargeCode = this.details.chargeCode;
      this.inputObject.currency = this.details.pricing.currency;
      this.inputObject.cadencetype = {
        label: this.details.pricing.cadence,
        value: this.details.pricing.cadence,
      };
      this.inputObject.eventType = {
        label: this.details.pricing.eventType,
        value: this.details.pricing.eventType,
      };
      this.inputObject.uom = {
        label: this.details.pricing.uom,
        value: this.details.pricing.uom,
      };
      this.inputObject.baseQuantity = this.details.pricing.baseQuantity;
      this.inputObject.price = this.details.pricing.price;
      this.inputObject.autoRenewal = this.details.autoRenewal;
      let accessRuleFilter = this.$store.getters[
        "accessrule/accessRuleList"
      ].filter((obj) => {
        return obj._id == this.details.planAccess;
      });
      if (accessRuleFilter.length > 0) {
        this.inputObject.planAccess = {
          label: accessRuleFilter[0].name.toUpperCase(),
          value: accessRuleFilter[0]._id,
        };
      } else {
      }
      this.inputObject.planType = {
        label: this.details.provisioning.planType,
        value: this.details.provisioning.planType,
      };
      this.inputObject.validity = this.details.provisioning.validity;
      this.inputObject.planlimit = this.details.provisioning.planLimit;
      let firstFeatureKey = true;
      this.inputObject.planFeatures = [];
      this.details.planFeatures.forEach((obj) => {
        if (firstFeatureKey) {
          this.inputObject.planFeatures.push({
            planFeatures: obj,
            isRemovable: false,
            text: "Add",
          });
          firstFeatureKey = false;
        } else {
          this.inputObject.planFeatures.push({
            planFeatures: obj,
            isRemovable: true,
            text: "Remove",
          });
        }
      });
    },
    async onClickEamilButton(item, idx) {
      const { isRemovable } = item;
      if (!isRemovable)
        this.inputObject.planFeatures.push({
          planFeatures: "",
          isRemovable: true,
          text: "Remove",
        });
      else this.inputObject.planFeatures.splice(idx, 1);
    },
    async handleSubmit() {
      let x = [];
      this.inputObject.orgAccessList.forEach((obj) => {
        x.push(obj.keys);
      });
      let data = {};
      data = {
        // scope: this.inputObject.scope.value,
        planName: this.inputObject.planName,
        isActive: this.inputObject.isActive,
        planDescription: this.inputObject.description,
        planFeatures: this.inputObject.planFeatures.map((t) => t.planFeatures),
        // provisioning: {
        //   planLimit: this.inputObject.planlimit,
        //   planType: this.inputObject.planType.value,
        //   validity: this.inputObject.validity
        // },
        // planAccess: this.inputObject.planAccess.value,
        // paymentType: this.inputObject.paymentType.value,
        autoRenewal: this.inputObject.autoRenewal,
        // taxCode: this.inputObject.taxCode.value,
        // chargeCode: this.inputObject.chargeCode,
        // pricing: {
        //   cadence: this.inputObject.cadencetype.value,
        //   eventType: this.inputObject.eventType.value,
        //   price: this.inputObject.price,
        //   currency: this.inputObject.currency,
        //   baseQuantity: this.inputObject.baseQuantity,
        //   uom: this.inputObject.uom.value
        // },
        // orgAccess: {
        //   orgAccessLevel: this.inputObject.orgAccessLevel.value,
        //   orgAccessList: x
        // }
      };
      let payload = {
        id: this.details._id,
        data: data,
      };
      console.log(data, "himanchal");
      const response = await this.$store
        .dispatch("subscriptionplan/editSubscription", payload)
        .then(async (result) => {
          console.log("result", result);
          this.$emit("edit", {});
          this.$swal({
            title: "Success",
            text: "Subscriptionplan Updated successfully!!",
            type: "success",
          });
          await this.$store
            .dispatch(
              "subscriptionplan/subscriptionplanList",
              this.$store.getters["auth/getUserID"]
            )
            .then((data) => {
              if (data.message) {
                this.$toasted.error(data.message);
              } else {
              }
            })
            .catch((err) => {
              console.log("err", err);
            });
        })
        .catch((err) => {
          console.log("err", err);
          this.$swal({
            title: "Opps!!!!!",
            text: "Can not Update Subscriptionplan!!",
            type: "error",
          });
        });
      this.$store.dispatch(
        "subscriptionplan/subscriptionList",
        this.$store.getters["auth/getUserID"]
      );
    },
  },
  async mounted() {
    this.loading = true;
    //this.getCatalogName();
    this.$store.dispatch("taxcode/fetchTaxcodeListforTenant");
    this.$store.dispatch("partner/fetchPartnersList").then((data) => {
      if (data.message) {
        this.$toasted.error(data.message);
      }
    });
    this.$store.dispatch("role/fetchRoles");
    await this.$store
      .dispatch(
        "taxcode/fetchTaxcodeListforTenant",
        this.$store.getters["auth/getUserID"]
      )
      .then((data) => {
        if (data.message) {
          this.$toasted.error(data.message);
        } else {
        }
      });
    await this.$store
      .dispatch(
        "accessrule/accessRuleList",
        this.$store.getters["auth/getUserID"]
      )
      .then((data) => {
        if (data.message) {
          this.$toasted.error(data.message);
        } else {
        }
      });
    this.fetchingAllData();
    this.loading = false;
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
.myDIV:hover + .hide {
  display: block;
  position: absolute;
}
.hide {
  display: none;
  font-size: 11px;
}
</style>
